export default {
      id: "vagues-titre-usage",
      viewBox: "0 0 70 48",
      url: "../dist/images/" + "sprite.svg#vagues-titre-usage",
      toString: function () {
        return this.url;
      }
    }